import FormControl from '@/ui-kit/components/form/entities/FormControl';
import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import { requiredFormValidator } from '@/ui-kit/components/form/validators';

interface BuilderListingAssignmentFormValue {
  cancellationReason: string;
}

const createPMCancellationFormGroup = (): FormGroup<BuilderListingAssignmentFormValue> => {
  const cancellationReasonControl = new FormControl('', [requiredFormValidator]);

  return new FormGroup({ cancellationReason: cancellationReasonControl });
};

export default createPMCancellationFormGroup;
